import { render, staticRenderFns } from "./ot-factor-selection.vue?vue&type=template&id=4906782e&scoped=true&"
import script from "./ot-factor-selection.vue?vue&type=script&lang=ts&"
export * from "./ot-factor-selection.vue?vue&type=script&lang=ts&"
import style0 from "./ot-factor-selection.vue?vue&type=style&index=0&id=4906782e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4906782e",
  null
  
)

export default component.exports